module.exports = __webpack_public_path__ + "static/media/cusd2.6c220812.jpg";